type InputmaskEvent = Pick<Event, 'target'> | null | undefined;

type InputmaskInstance = {
  unmaskedvalue?: () => string | number;
  userOptions?: {
    alias?: string;
  };
};

export type InputmaskTarget = EventTarget & {
  inputmask?: InputmaskInstance;
  value?: string;
  valueAsNumber?: number;
};

export function getInputmaskTarget(event: InputmaskEvent) {
  return event?.target as InputmaskTarget | null | undefined;
}

export function getInputmaskAlias(event: InputmaskEvent) {
  return getInputmaskTarget(event)?.inputmask?.userOptions?.alias;
}

export function getInputmaskUnmaskedValue(event: InputmaskEvent) {
  return getInputmaskTarget(event)?.inputmask?.unmaskedvalue?.();
}
